import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import answerimg from '../../images/answer.png'
import s from '../../services/allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../../stylesheet/forcechangepassword.css'
import '../../stylesheet/changepassword.css'

import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';
// import logo from "../../images/GM-Cabs-card-logo.jpg";
import $ from 'jquery'
import GuestNav from '../navigation/guestnavbar.jsx'
import DatePicker from 'material-ui/DatePicker';
import {
    withRouter
} from 'react-router-dom';
import '../../stylesheet/forcesecretquestion.css'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js'
import OtpPopup from '../otp/OtpPopup.js';
// import LoaderSmall from "../loader/loadersmall.jsx"

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    secretQues: state.secretQuesReducer.secretQues,
})

const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchSecretQues(quesReceived) {
        dispatch(
            actions.secretQuesAction(quesReceived)
        )
    }
})
// const JSEncrypt = window.JSEncrypt

class ForceChangesecretque extends Component {
    constructor(props) {
        super(props);
        this.state = {
            correctPassword: true,
            correctPassword1: true,
            confirmPasswordErr: true,
            newPassword: "",
            confirmPassword: "",
            value: "",
            secretAnswer: "",
            disabled: true,
            correctDob: true,
            otpOpen: false,
            otp: "",
            popupLoader: false,

            secretQuestionError: "",
            secretAnswerError: "",
            passwordError: "",

        }
    }
    handleConfirmPassword = (e, value) => {
        let _this = this
        if (e.target.value === this.state.newPassword) {
            this.setState({
                [e.target.name]: e.target.value,
                confirmPasswordErr: true
            }, () => {
                if (_this.state.newPassword !== "" && _this.state.secretAnswer !== "" && _this.state.value !== "") {
                    this.setState({
                        disabled: false
                    })
                }
                else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }
        else {
            this.setState({
                confirmPasswordErr: false,
                disabled: true
            })
        }

    }


    onChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        this.setState(
            {
                [name]: value,
                correctDob: true
            },
            () => {
                this.validateForm();
            }
        );
    };


    handleChange = (e) => {

        var myInput = document.getElementById("psw");
        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        var spec = document.getElementById("sp");

        // Show password helper
        myInput.onfocus = function () {
            document.getElementById("errmessagebody").style.display = "block";
        }

        // Hide password helper
        myInput.onblur = function () {
            document.getElementById("errmessagebody").style.display = "none";
        }

        myInput.onkeyup = function () {

            var lowerCaseLetters = /[a-z]/g;
            if (myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            var upperCaseLetters = /[A-Z]/g;
            if (myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            var numbers = /[0-9]/g;
            if (myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            if (myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            var spe = /(?=.*[!@.+-,'#\$%\^&\*])/g;
            if (myInput.value.match(spe)) {
                spec.classList.remove("invalid");
                spec.classList.add("valid");
            } else {
                spec.classList.remove("valid");
                spec.classList.add("invalid");
            }
        };

        var passwd = new RegExp(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\\$%\\^&\\*])(?=.{8,})"
        );

        if (e.target.name === "newPassword") {

            const value = e.target.value;

            this.setState(
                {
                    newPassword: value,
                    correctPassword1: passwd.test(value),
                    disabled: !(
                        passwd.test(value) &&
                        this.state.secretAnswer !== "" &&
                        this.state.value !== ""
                    )
                },
                () => {
                    if (typeof this.validateForm === "function") {
                        this.validateForm();
                    }
                }
            );
        }
    };
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
        this.props.fetchSecretQues(false)
    }

    otpPopupOpenModal = () => {
        const {
            value,
            secretAnswer,
            newPassword,
            correctPassword1,
            correctDob
        } = this.state;

        if (!value || !secretAnswer || !newPassword) {
            toast.error('Please Enter Data In Required Fields', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (correctPassword1 === false) {
            toast.error('Invalid Password', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        if (correctDob === false) {
            toast.error('Enter correct format', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        const otpValidation = localStorage.getItem('otpValidation');

        if (otpValidation === 'false') {
            // Skip OTP modal — call final API directly
            this.setState({ otp: "" }, () => {
                this.changeSecretQuestion(null, null);
            });
        } else {
            // Show OTP modal as usual
            this.setState({ otpOpen: true }, () => {
                this.handleRequestOtp(false);
            });
        }
    };
    otpPopupCloseModal = () => {

        this.setState({
            otpOpen: false,
        });
    };
    handleRequestOtp = (isResend = false) => {

        let token = "Token " + localStorage.getItem("token");

        let plink =
            localStorage.getItem("pform") === "AU"
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        let traceId = getClientId();

        let otpUrl = s.otp_change_seq_que;

        if (isResend) {
            otpUrl = `${s.otp_change_seq_que}/true`;
        }

        fetch(plink + otpUrl, {

            method: "GET",

            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: token,
                "X-Trace-Id": traceId,
                "X-KlickEx-Client": buildClientHeader(),
            })

        })
            .then((response) => {

                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {

                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });

                }
                else if (response.status === 401) {

                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout')
                    }

                }
                else {

                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            });

    };
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {

            this.changeSecretQuestion(onSuccess, onError);

        });

    };
    otpPopupCloseModal = () => {

        this.setState({
            otpOpen: false,
            popupLoader: false,
        });

    };
    handleSubmit1 = () => {
        this.props.history.push('/');
    }

    handleSelect = (event, index, value) => {

        this.findDescription(value);

        this.setState(
            {
                value,
                secretAnswer: "",
                correctDob: true
            },
            () => {
                this.validateForm();
            }
        );
    };
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }
    // handleDate = (e, date) => {
    //     this.setState({
    //         secretAnswer: this.converDate(date),
    //         disabled: false
    //     })
    // }
    handleDate = (e, date) => {

        this.setState(
            {
                secretAnswer: this.converDate(date),
                correctDob: true
            },
            () => {
                this.validateForm();
            }
        );
    };
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }
    changeSecretQuestion(onSuccess, onError) {
        let state = {
            accountId: localStorage.getItem('accountId'),
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            secretPassword: this.state.secretAnswer,
            secretQuestionCode: this.state.value,
            currentPassword: this.state.newPassword,
            otp: this.state.otp
        }
        let _this = this
        let token = "Token " + localStorage.getItem('token')
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.change_seq_que, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': token,
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    // this.setState({
                    //     loader: false
                    // })
                    // setTimeout(function () {
                    //     _this.props.history.push('/home');
                    // }, 3000);
                    if (onSuccess) {
                        onSuccess();
                    }

                    this.setState({
                        popupLoader: false,
                        loader: true
                    }, () => {

                        setTimeout(() => {

                            this.setState({
                                loader: false
                            });

                            _this.props.history.push('/home');

                        }, 3000);

                    });
                }
                else if (response.status === 400) {
                    this.setState({
                        popupLoader: false,
                        loader: false
                    });

                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                    this.setState({
                        loader: false
                    })

                }
                else if (response.status === 401) {

                    this.setState({
                        popupLoader: false,
                        loader: false
                    });

                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout')
                    }

                }
                else if (response.status === 422) {

                    this.setState({
                        popupLoader: false,
                        loader: false,
                    });
                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    let message = response.headers.get("message");

                    response.json().then((json) => {
                        message = json.message
                            ? json.message
                            : response.headers.get("message");

                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });
                    });

                    // toast.error(message, {
                    //     position: "top-right",
                    //     autoClose: 3000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     draggablePercent: 60,
                    // });

                }

                else {
                    this.setState({
                        popupLoader: false,
                        loader: false
                    });

                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    this.setState({
                        loader: false
                    })
                }
            })
    }
    validatePassword(e) {
        e.preventDefault();
        // eslint-disable-next-line
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword1: true
                })

            }

            else {
                this.setState({
                    correctPassword1: false
                })
            }
        }

    }
    validateForm = () => {

        const {
            value,
            secretAnswer,
            newPassword
        } = this.state;

        let secretQuestionError = "";
        let secretAnswerError = "";
        let passwordError = "";

        const passwd =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+\-,'#$%^&*])(?=.{8,})/;

        if (!value) {
            secretQuestionError = "Secret question is required";
        }

        if (value === "DOB") {

            if (!secretAnswer) {
                secretAnswerError = "Secret answer is required";
            }

        } else {

            if (!secretAnswer || secretAnswer.trim() === "") {
                secretAnswerError = "Secret answer is required";
            }

        }

        if (!newPassword) {
            passwordError = "Current password is required";
        }
        else if (!passwd.test(newPassword)) {
            passwordError =
                "Password must contain uppercase, lowercase, number and special character";
        }

        this.setState({
            secretQuestionError,
            secretAnswerError,
            passwordError,
            correctPassword1: passwd.test(newPassword)
        });
    };

    render() {
        const { secretQues } = this.props
        const { correctPassword1, correctDob } = this.state
        const height = $(window).height() - 108;
        //     const isFormValid =
        // this.state.value &&
        // this.state.secretAnswer &&
        // this.state.newPassword &&
        // !this.state.secretQuestionError &&
        // !this.state.secretAnswerError &&
        // !this.state.passwordError;
        const isFormValid =
            this.state.value &&
            this.state.secretAnswer &&
            this.state.secretAnswer.toString().trim() !== "" &&
            this.state.newPassword &&
            !this.state.secretQuestionError &&
            !this.state.secretAnswerError &&
            !this.state.passwordError;
        return (
            <div className="col-md-12 forcechangepwd" style={{ minHeight: height }}>
                <GuestNav />
                {this.state.otpOpen && (
                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}
                <div className="row">
                    <div className="col-md-3">
                        <div id="errmessagebody" style={{ marginTop: "80px", marginLeft: "10px" }} >
                            <span style={{ fontSize: "14px", marginLeft: "10px" }}> Password must contain following:</span><br />
                            <div style={{ marginTop: "8px", padding: "0px 15px" }}>
                                <span id="length" className="invalid">At least 8 to 15 characters </span><br />
                                <span id="capital" className="invalid">At least one upper case alphabet</span><br />
                                <span id="letter" className="invalid">At least one lower case alphabet</span><br />
                                <span id="sp" className="invalid">At least one special character ( ! @ # $ % ^ & * )</span><br />
                                <span id="number" className="invalid">At least one number</span><br />

                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                        style={{ zIndex: 999999 }}
                    />

                    <div className="col-md-7" style={{ marginTop: "80px" }}>
                        <div className="">
                            <div className="row">
                                <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                    <div className="summary-header">
                                        <div className="row">
                                            <div className="col-md-6 ml-0 pl-0">
                                                <h4 className='logmainheading mainheading'>Change Secret Question and Password</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-sm-12">
                                    <div className="row input-group">
                                        {/* <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                        </div> */}
                                        <div className="col-md-6 col-sm-12" >
                                            <SelectField
                                                value={this.state.value}

                                                onChange={this.handleSelect}
                                                name="secretQuestionCode"

                                                floatingLabelText="Secret Question"
                                                className="input-width required"
                                            >
                                                {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                    <MenuItem className="menuitem" value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                ) : <div>Select Question</div>}
                                            </SelectField>
                                            {
                                                this.state.secretQuestionError && (
                                                    <div
                                                        style={{
                                                            color: "red",
                                                            fontSize: "12px",
                                                            marginTop: "-10px"
                                                        }}
                                                    >
                                                        {this.state.secretQuestionError}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row input-group" >
                                        <div className="col-md-6 col-sm-9" >
                                            {/* {(this.state.value === "DOB") ?
                                        
                                                <DatePicker hintText="Birthday"
                                                    // container="inline" mode="landscape"
                                                    openToYearSelection={true}
                                                    floatingLabelText="Secret Answer(Date Of Birth)"
                                                    style={{ width: "100%" }}
                                                    type="text"
                                                    name="secretAnswer"
                                                    onChange={this.handleDate}
                                                    id="secretAns"
                                                    maxDate={new Date()}
                                                    formatDate={this.formatDate}
                                                    className="input-width required"
                                                    // defaultValue={this.state.secretAnswerDate || null}
                                                    // defaultDate={( new Date(this.state.secretAnswerDate))} 
                                                    // defaultDate={ this.state.secretAnswerDate}
                                                    defaultDate={(this.state.secretAnswerDate) ? new Date(this.state.secretAnswerDate) : this.state.secretAnswerDate}

                                                    // defaultDate={new Date()}
                                                    // defaultDate= {new Date()}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle} />
                                                :
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Secret Answer"
                                                    type="text"
                                                    name="secretAnswer"
                                                    autoComplete='off'
                                                    maxLength="50"
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    // errorText={correctDob ? null : "Enter correct format"}
                                                    errorText={
    this.state.secretAnswerError ||
    (correctDob ? null : "Enter correct format")
}
                                                />

                                            } */}

                                            {(this.state.value === "DOB") ?
                                                <div>
                                                    <DatePicker
                                                        hintText="Birthday"
                                                        openToYearSelection={true}
                                                        floatingLabelText="Secret Answer(Date Of Birth)"
                                                        style={{ width: "100%" }}
                                                        type="text"
                                                        name="secretAnswer"
                                                        onChange={this.handleDate}
                                                        id="secretAns"
                                                        maxDate={new Date()}
                                                        formatDate={this.formatDate}
                                                        className="input-width required"
                                                        defaultDate={
                                                            (this.state.secretAnswerDate)
                                                                ? new Date(this.state.secretAnswerDate)
                                                                : this.state.secretAnswerDate
                                                        }
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                    />

                                                    {
                                                        this.state.secretAnswerError && (
                                                            <div
                                                                style={{
                                                                    color: "red",
                                                                    fontSize: "12px",
                                                                    marginTop: "-10px"
                                                                }}
                                                            >
                                                                {this.state.secretAnswerError}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                :
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Secret Answer"
                                                    type="text"
                                                    name="secretAnswer"
                                                    autoComplete="off"
                                                    maxLength="50"
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    errorText={
                                                        this.state.secretAnswerError ||
                                                        (correctDob ? null : "Enter correct format")
                                                    }
                                                />
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-sm-12">
                                    <div className="row input-group" >
                                        <div className="col-md-6 col-sm-9" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Current Password"
                                                type="password"
                                                id="psw"
                                                maxLength="15"
                                                name="newPassword"
                                                autoComplete='none'
                                                className="input-width required"
                                                onFocus={this.handleChange.bind(this)}
                                                onChange={this.handleChange.bind(this)}
                                                onBlur={this.validatePassword.bind(this)}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={correctPassword1 ? null : "Invalid Password."}
                                                errorText={this.state.passwordError}
                                            />
                                            <span toggle="#psw" className=" col-sm-1 fa fa-fw fa-eye-slash field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                        {/* <div className="col-sm-1 tooltip" style={{ top: "35px" }}>
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            <span className="tooltiptext" style={{ fontSize: "12px" }} >Your Password must contain at least 8 character, one number, one lowercase ,special character and one uppercase letter </span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row input-group" >
                                        {/* <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Confirm Password"
                                                type="password"
                                                id="loginpassword"
                                                maxLength="15"
                                                name="confirmPassword"
                                                autoComplete='none'
                                                className="input-width required"
                                                style={{ zIndex: "0" }}
                                                onChange={this.handleConfirmPassword}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={confirmPasswordErr ? null : "New Password And Confirm Password Should Be Same."}
                                            />
                                            <span className="col-sm-1" toggle="#loginpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-3 mb-3 ml-3">
                                    <div className="row">


                                        <RaisedButton
                                            label="Cancel"
                                            className=" btn-std"
                                            // style={styles.button}
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            onClick={this.handleSubmit1.bind(this)}
                                            style={{ marginTop: "10px" }}
                                        />
                                        <RaisedButton
                                            label="Change"
                                            className="ml-3 btn-std mr-2"

                                            // style={styles.button}
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            // onClick={this.changeSecretQuestion.bind(this)}
                                            onClick={this.otpPopupOpenModal}
                                            style={{ marginTop: "10px" }}
                                            // disabled={this.state.disabled}
                                            disabled={!isFormValid}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForceChangesecretque));



// WEBPACK FOOTER //
// ./src/components/forcesecretPassword/forcesecretPassword.jsx